import gql from 'graphql-tag';

export const PROJECTS_SUMMARY_QUERY = {
  es: gql`
    query ProjectsSummaryCollection {
      projectsCollections(sort: "projectDate:desc") {
        slug
        title: title_es
        summary: summary_es
        projectDate
        location
        category {
          id
          name: name_es
          icon
        }
        cover {
          url
          alternativeText
        }
      }
    }
  `,
  en: gql`
    query ProjectsSummaryCollection {
      projectsCollections(sort: "projectDate:desc") {
        slug
        title: title_en
        summary: summary_en
        projectDate
        location
        category {
          id
          name: name_en
          icon
        }
        cover {
          url
          alternativeText
        }
      }
    }
  `
};

export const PROJECTS_FOR_HOME_QUERY = {
  es: gql`
    query ProjectsForHomeCollection {
      projectsCollections(limit: 9, sort: "projectDate:desc") {
        slug
        title: title_es
        location
        projectDate
        category {
          name: name_es
          icon
        }
        cover {
          url
          alternativeText
        }
      }
    }
  `,
  en: gql`
    query ProjectsForHomeCollection {
      projectsCollections(limit: 9, sort: "projectDate:desc") {
        slug
        title: title_en
        location
        projectDate
        category {
          name: name_en
          icon
        }
        cover {
          url
          alternativeText
        }
      }
    }
  `
};

export const PROJECT_BY_SLUG = {
  es: gql`
    query ProjectBySlug($slug: String!) {
      projectsCollections(where: { slug: $slug }) {
        slug
        title: title_es
        summary: summary_es
        description: description_es
        projectDate
        location
        category {
          name: name_es
          icon
        }
        cover {
          url
          alternativeText
        }
        multimedia {
          mime
          ext
          url
          alternativeText
        }
      }
    }
  `,
  en: gql`
    query ProjectBySlug($slug: String!) {
      projectsCollections(where: { slug: $slug }) {
        slug
        title: title_en
        summary: summary_en
        description: description_en
        projectDate
        location
        category {
          name: name_en
          icon
        }
        cover {
          url
          alternativeText
        }
        multimedia {
          mime
          ext
          url
          alternativeText
        }
      }
    }
  `
};
